<div class="table-filters with-border-b d-flex flex-nowrap align-items-center" *ngIf="open">
    <button class="pr-2 btn btn-secondary border-transparent"
            type="button"
            (click)="toggleSelector()">
        <span [attr.aria-label]="'Show/Hide filter selector' | translate"
              class="fas fa-filter"></span> &nbsp;&nbsp;
        <span translate>Filter</span>
    </button>
    <div class="table-filters-selector-container mr-auto">
        <table-filters-selector [(showDropdown)]="showDropdown"
                                [model]="model"
                                [filters]="filters"
                                (onChanges)="onFiltersChange($event)"
                                [selectorItemTemplate]="selectorItemTemplate"
                                [show]="open">
        </table-filters-selector>
    </div>
    <div (click)="clear()"
         (keyup.enter)="clear()"
         role="button"
         tabindex="0"
       [attr.aria-label]="'Clear and close filters' | translate"
       [ngbTooltip]="'Clear and close filters' | translate"
       class="table-filters-clear">
        <span class="fas fa-times" aria-hidden="true"></span>
    </div>
</div>
